
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class DispatchBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class DispatchBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:  string = data._id.match(/^dis-(.*)/i)[1];
    let name: string = `Dispatch #${u}`;
    let depart:  any = null;

    /*
     * decision point groups, dispatches and deployments can all be a branch in the tree that
     * was actually used for move a train.  Many of these branches are not...because the attempt
     * is made to move the train, but it can't for any number of reasons.  THe branches that do
     * get used...should normally be the most recent branch in the parent; since we move trains
     * as soon as they can move.
     *
     * Regardless, we let the simulator tell us what the "actual" move branches are; the parent
     * will have its 'depart' field filled in with a pointer to the depart event that ties together
     * all levels of the branch of the context tree that was used in an actual train move.  So,
     * if that depart field is filled in...then we check to see if our level is in the "actual"
     * branch.
     *
     */

    if ((typeof args.parent.depart != 'undefined') && (args.parent.depart != null)) {

      if (data._id == args.parent.depart.td) {

        /* yup, this is an actual move branch */

        name = `#${u} ${args.parent.depart.d}`;

      }

      depart = args.parent.depart;
    }

    /* build it! */

    return {
      id:          data._id,
      seq:         parseInt(data.seq),
      index:       args.index,
      name,
      hasChildren: args.hasChildren,
      isExpanded:  args.isExpanded,
      type:        'dispatch',
      children:    args.children,
      parent:      args.parent,
      kids:        data.ch,
      depart,
      tags:        data.tg,
      label:       data.lb,
      pkey:        data.pa,
      u
    };

  }
}
